{
  "GENERAL": {
    "SHOWING_RESULTS": "顯示第 {firstIndex}-{lastIndex} 項，共 {totalCount} 項",
    "PHONE_INPUT": {
      "PLACEHOLDER": "搜尋",
      "EMPTY_STATE": "查無結果"
    },
    "CLOSE": "關閉",
    "BETA": "Beta",
    "BETA_DESCRIPTION": "此功能目前為 Beta 版本，我們仍在持續改善中。",
    "ACCEPT": "接受",
    "DISCARD": "捨棄",
    "PREFERRED": "偏好"
  },
  "CHOICE_TOGGLE": {
    "YES": "是",
    "NO": "否"
  }
}
